<template lang="pug">
  v-container
    v-col(cols="12" style="position: relative;")
      v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
      h2.transactions__title.transactions__underline Movimientos
    v-row.justify-center.my-2.mx-2.transactions__container
      template(v-for="(item, i) in items")
        v-list-item(:to="item.to")
          v-list-item-avatar
            v-icon(color="primary")
              | {{item.action}}
          v-list-item-content
            v-list-item-title(v-text="item.title")
          v-list-item-icon
            v-icon(color="grey")
              | mdi-chevron-right
        v-divider(v-if="i !== items.length-1").divider-length(style="border-color:#b1b1b1 !important")
</template>

<script>
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  export default {

    components: {
      shopPlaceHolder: shopPlaceHolder,
      NoResults: () => import('@/components/custom/NoResults'),
    },

    data: () => ({
    }),

    computed: {
      items () {
        return [
          {
            action: 'mdi-ticket',
            title: this.$t('drawer.sales'),
            to: 'transactions/sales',
          },
          {
            action: 'mdi-silverware-fork-knife',
            title: this.$t('drawer.orders'),
            to: 'transactions/orders',
          },
          {
            action: 'mdi-school',
            title: this.$t('drawer.purchases'),
            to: 'transactions/purchases',
          },
          {
            action: 'mdi-run',
            title: this.$t('drawer.transfers'),
            to: 'transactions/transfers',
          },
          {
            action: 'mdi-bottle-tonic-plus',
            title: this.$t('drawer.expenses'),
            to: 'transactions/expenses',
          },
          {
            action: 'mdi-content-cut',
            title: this.$t('drawer.returns'),
            to: 'transactions/returns',
          },
          {
            action: 'mdi-book',
            title: this.$t('drawer.logs'),
            to: 'transactions/logs',
          },
          {
            action: 'mdi-store',
            title: 'Cambio de inventario',
            to: 'transactions/inventory',
          },
          /* {
            action: 'mdi-content-cut',
            title: this.$t('drawer.add_inventory'),
            to: 'transactions/add-inventory',
          }, */
        ]
      },
    },

    methods: {
      getImage (url) {
        // console.log(url)
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
      gotoShop (id) {
        // console.log(id)
        const vm = this
        vm.$router.push(`shops/${id}`)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .transactions {
    &__container {
      background-color: #fff;
      box-shadow: 0 .9375rem 2.5rem rgba(#000, .15);
      border-radius: 10px;
    }

    &__title {
      text-align: center;
      color:#a3a4a5;
      margin-bottom: 1.5rem;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }
</style>
